<template>
    <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
        <a-divider orientation="left">
            <b>{{ formTitle }}</b>
        </a-divider>
        <a-form-model ref="form" :model="form" :rules="rules">
            <b>标题为站内信中展示的标题，文案是弹窗和站内信通用</b>
            <a-form-model-item label="用户ID" prop="userIds">
                <a-input v-model="form.userIds" placeholder="多个用户ID使用,隔开" />
            </a-form-model-item>
            <a-form-model-item label="繁中标题" prop="rewardTitle">
                <a-input v-model="form.rewardTitle" />
            </a-form-model-item>
            <a-form-model-item label="繁中文案" prop="rewardContent">
                <a-input v-model="form.rewardContent" />
            </a-form-model-item>
            <a-form-model-item label="英文标题" prop="rewardTitleEn">
                <a-input v-model="form.rewardTitleEn" />
            </a-form-model-item>
            <a-form-model-item label="英文文案" prop="rewardContentEn">
                <a-input v-model="form.rewardContentEn" />
            </a-form-model-item>
            <a-form-model-item label="日语标题" prop="rewardTitleJa">
                <a-input v-model="form.rewardTitleJa" />
            </a-form-model-item>
            <a-form-model-item label="日语文案" prop="rewardContentJa">
                <a-input v-model="form.rewardContentJa" />
            </a-form-model-item>

            <a-form-model-item label="印尼标题" prop="rewardTitleId">
                <a-input v-model="form.rewardTitleId" />
            </a-form-model-item>
            <a-form-model-item label="印尼文案" prop="rewardContentId">
                <a-input v-model="form.rewardContentId" />
            </a-form-model-item>

            <a-form-model-item label="葡语标题" prop="rewardTitlePt">
                <a-input v-model="form.rewardTitlePt" />
            </a-form-model-item>
            <a-form-model-item label="葡语文案" prop="rewardContentPt">
                <a-input v-model="form.rewardContentPt" />
            </a-form-model-item>

            <a-form-model-item label="西语标题" prop="rewardTitleEs">
                <a-input v-model="form.rewardTitleEs" />
            </a-form-model-item>
            <a-form-model-item label="西语文案" prop="rewardContentEs">
                <a-input v-model="form.rewardContentEs" />
            </a-form-model-item>

            <a-form-model-item label="奖励类型" prop="type">
                <a-select placeholder="请选择奖励类型" v-model="form.type">
                    <a-select-option :key="0">会员</a-select-option>
                    <a-select-option :key="1">金币</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="发放数量" prop="number">
                <a-input v-model="form.number" placeholder="请输入发放数量" />
            </a-form-model-item>
            <a-form-model-item label="有效时间" prop="expiresTime">
                <a-input v-model="form.expiresTime" placeholder="天数 例如：1" />
            </a-form-model-item>
            <a-form-model-item label="备注" prop="remark">
                <a-input v-model="form.remark" placeholder="备注" />
            </a-form-model-item>
            <div class="bottom-control">
                <a-space>
                    <a-button type="primary" :loading="submitLoading" @click="submitForm">
                        保存
                    </a-button>
                    <a-button type="dashed" @click="cancel">
                        取消
                    </a-button>
                </a-space>
            </div>
        </a-form-model>
    </a-drawer>
</template>
  
<script>
import { add, update, detail } from '@/api/privilegeCampaign/privilegeCampaign'

export default {
    name: 'CreateForm',
    props: {
    },
    components: {
    },
    data() {
        return {
            submitLoading: false,
            formTitle: '',
            // 表单参数
            form: {
                id: null,
                rewardContent: null,
                rewardContentEn: null,
                rewardContentJa: null,
                rewardTitle: null,
                rewardTitleEn: null,
                rewardTitleJa: null,
                rewardContentId: null,
                rewardContentPt: null,
                rewardContentEs: null,
                rewardTitleId: null,
                rewardTitlePt: null,
                rewardTitleEs: null,
                userIds: null,
                type: null,
                number: null,
                expiresTime: null,
                remark: null,
                createTime: null,
            },
            // 1增加,2修改
            formType: 1,
            open: false,
            rules: {
                userIds: [
                    { required: true, message: '请输入用户ID', trigger: 'blur' },
                ],
                rewardTitle: [
                    { required: true, message: '请输入繁中标题', trigger: 'blur' }
                ],
                rewardContent: [
                    { required: true, message: '请输入繁中文案', trigger: 'blur' }
                ],
                rewardTitleEn: [
                    { required: true, message: '请输入英文标题', trigger: 'blur' }
                ],
                rewardContentEn: [
                    { required: true, message: '请输入英文文案', trigger: 'blur' }
                ],
                rewardTitleJa: [
                    { required: true, message: '请输入日语标题', trigger: 'blur' }
                ],
                rewardContentJa: [
                    { required: true, message: '请输入日语文案', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择奖励类型', trigger: 'change' }
                ],
                number: [
                    { required: true, message: '请输入发放数量', trigger: 'blur' },
                ],
                expiresTime: [
                    { required: true, message: '请输入有效天数', trigger: 'blur' },
                ]
            }
        }
    },
    filters: {
    },
    created() {
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        onClose() {
            this.reset()
            this.open = false
        },
        // 取消按钮
        cancel() {
            this.open = false
            this.reset()
        },
        // 表单重置
        reset() {
            this.formType = 1
            this.form = {
                id: null,
                userIds: null,
                type: null,
                rewardContent: null,
                rewardContentEn: null,
                rewardContentJa: null,
                rewardTitle: null,
                rewardTitleEn: null,
                rewardTitleJa: null,
                rewardContentId: null,
                rewardContentPt: null,
                rewardContentEs: null,
                rewardTitleId: null,
                rewardTitlePt: null,
                rewardTitleEs: null,
                number: null,
                expiresTime: null,
                remark: null,
                createTime: null,
            }
            // this.$nextTick(() => {
            //   if(this.$refs.form){
            //     this.$refs.form.resetFields()
            //   }
            // })
        },
        /** 新增按钮操作 */
        handleAdd(row) {
            this.reset()
            this.formType = 1
            this.open = true
            this.formTitle = '添加'
            this.form = {
                id: null,
                userIds: null,
                type: null,
                rewardContent: null,
                rewardContentEn: null,
                rewardContentJa: null,
                rewardTitle: null,
                rewardTitleEn: null,
                rewardTitleJa: null,
                rewardContentId: null,
                rewardContentPt: null,
                rewardContentEs: null,
                rewardTitleId: null,
                rewardTitlePt: null,
                rewardTitleEs: null,
                number: null,
                expiresTime: null,
                remark: null,
                createTime: null,

            }
        },
        /** 修改按钮操作 */
        handleUpdate(row, ids) {
            this.reset()
            this.formType = 2
            const id = row ? row.id : ids
            detail({ "id": id }).then(response => {
                this.form = response.data
                this.vipdays = this.form.isOffline
                this.open = true
                this.formTitle = '修改'
            })
        },
        /** 提交按钮 */
        submitForm: function () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    if (this.form.id !== undefined && this.form.id !== null) {
                        update(this.form).then(response => {
                            this.$message.success(
                                '修改成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    } else {
                        add(this.form).then(response => {
                            this.$message.success(
                                '新增成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>
  